var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useField, useFormikContext } from 'formik';
import { useSearchableMenuFuse, SearchableMenuProvider, SearchableMenuSearchHeader, SearchableMenuMultiSelectList, } from 'shared/domains/common-ui/SearchableMenu';
export function MultiSelectList(props) {
    const { data } = props;
    const { submitForm } = useFormikContext();
    const [field, , helpers] = useField({
        name: 'value',
    });
    const searchableItems = data.map((item) => (Object.assign({ id: item.value }, item)));
    const selected = Array.isArray(field.value) ? field.value : [];
    const search = useSearchableMenuFuse(searchableItems, {
        keys: ['text'],
    });
    const handleSelectItem = (item) => __awaiter(this, void 0, void 0, function* () {
        const isSelected = selected.includes(item);
        if (isSelected) {
            yield helpers.setValue(selected.filter((value) => value !== item));
        }
        else {
            yield helpers.setValue([...selected, item]);
        }
        return submitForm();
    });
    return (<SearchableMenuProvider {...search}>
      <SearchableMenuSearchHeader />
      <SearchableMenuMultiSelectList onSelect={(item) => handleSelectItem(item.id)} renderItem={({ text }) => text} selected={selected || []}/>
    </SearchableMenuProvider>);
}
